import React, { Component } from 'react';
import { NavLink } from 'react-router-dom'
import './Navbar.css';
import Text from '../Text';
import { Back as BackIcon } from '../Icons';
import onSwipe from '../swipe';

const NavBarLink = ({ to, children }) => (
    <NavLink
        to={to}
        className="nav-bar__link"
        activeClassName="nav-bar__link--active"
    >
        {children}
    </NavLink>
);

class Navbar extends Component {
    constructor(props) {
        super(props);
        this.onNavSwipe = this.onNavSwipe.bind(this);
    }

    onNavSwipe(direction) {
        if (this.props.hidden || !(direction === 'left' || direction === 'right')) {
            // do not swipe in card detail mode since the nav bar is hidden
            return;
        }

        const { navLinks, location, history } = this.props;
        const currentRoute = location.pathname;
        const currentRouteIndex = navLinks.findIndex(navLink => navLink.route === currentRoute);
        if (currentRouteIndex >= 0) { // if current route is linked in navbar
            if (direction === 'left' && currentRouteIndex < navLinks.length - 1) {
                // go to the screen on the right
                history.push(navLinks[currentRouteIndex + 1].route);
            } else if (direction === 'right' && currentRouteIndex > 0) {
                // go to the screen on the left
                history.push(navLinks[currentRouteIndex - 1].route);
            }
        }
    }

    componentDidMount() {
        const appContainerEl = document.getElementById('root');
        onSwipe(appContainerEl, this.onNavSwipe);
    }

    render() {
        const { hidden, navLinks } = this.props;
        return (
            <nav className="page-nav">
                <button className={`back-btn ${hidden ? '' : 'back-btn--hidden'}`} onClick={() => { window.history.back(); }}>
                <BackIcon />
                zurück
                </button>
                <div className={`nav-bar ${hidden ? 'nav-bar--hidden' : ''}`}>
                    {navLinks.map(link => (
                        <NavBarLink to={link.route}>
                            <link.icon />
                            <Text>{link.text}</Text>
                        </NavBarLink>
                    ))}
                </div>
            </nav>
        );
    }
}

export default Navbar;



// WEBPACK FOOTER //
// ./src/navbar/Navbar.js